import { useEffect, useRef, useState } from "react";
import { pieceOf } from "@/components/game/SeaSquare";

const HOLD = 450;
const STEP = 150;
const RISE = 600;
const NONE = { rise: {}, splash: {} };

const colRow = (k) => k.split(",").map(Number);
const byColumn = (a, b) => {
  const [ra, ca] = colRow(a);
  const [rb, cb] = colRow(b);
  return ca - cb || rb - ra;
};

// Watches the board for squares the sea takes: water rises over them one by one (column order),
// walls that held splash, then the Sea Level Rise summary opens.
export function useSeaRise(game) {
  const prev = useRef(null);
  const timer = useRef(null);
  const [anim, setAnim] = useState(NONE);
  const [summary, setSummary] = useState(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  useEffect(() => {
    if (!game) return;
    const p = prev.current;
    const slr = game.slr_events || 0;
    prev.current = { cells: game.cells, slr };
    if (!p) return;
    const fresh = slr > p.slr && game.last_slr_summary ? game.last_slr_summary : null;
    const drowned = Object.keys(game.cells).filter((k) => game.cells[k]?.kind === "sea_marker" && p.cells[k]?.kind !== "sea_marker");
    // TERRAIN 2 of 3: squares Sea Walls hold back get the splash.
    const held = fresh?.held_back || [];
    const order = [...new Set([...drowned, ...held])].sort(byColumn);
    if (!order.length) {
      if (fresh) setSummary(fresh);
      return;
    }
    const rise = {};
    const splash = {};
    order.forEach((k, i) => {
      const delay = HOLD + i * STEP;
      if (held.includes(k)) splash[k] = delay;
      else rise[k] = { delay, piece: game.cells[k]?.drowned ? pieceOf(p.cells[k]) : null };
    });
    setAnim({ rise, splash });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setAnim(NONE);
      if (fresh) setSummary(fresh);
    }, HOLD + (order.length - 1) * STEP + RISE + 80);
  }, [game]);

  return { rise: anim.rise, splash: anim.splash, summary, closeSummary: () => setSummary(null) };
}
